import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    Button,
    Typography,
    MenuItem,
    InputLabel,
    FormControl,
    Select,
    InputAdornment,
    IconButton
} from '@mui/material';
import React, { useState, useRef } from 'react';
import { useTranslation } from "react-i18next";
import "../../css/components/Modals/CreateNewSecret.css";
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import "../../css/main.css";
import {Visibility, VisibilityOff} from "@mui/icons-material";

export default function NewSecretModal({ openSecretModal, handleSecretModalClose, handleCreateSecret, avoidMisfire, myUserPerms }) {
    const { t } = useTranslation();

    const [visibility, setVisibility] = React.useState(myUserPerms?.is_owner ? "Owner" : myUserPerms?.is_admin ? "Admin" : "User");
    const [title, setTitle] = useState("");
    const [secret, setSecret] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const inputRef = useRef(null);


    const handleVisibilityChange = (event) => {
        setVisibility(event.target.value);
    };

    const resetForm = () => {
        setTitle("");
        setSecret("");
        setShowPassword(false);
        setVisibility(myUserPerms?.is_owner ? "Owner" : myUserPerms?.is_admin ? "Admin" : "User");
    };

    const handleSaveSecret = () => {
        if (title.trim() === "" || secret.trim() === "") {
            // If Title or Secret is empty, prevent saving
            return;
        }
        // Call handleCreateSecret function if Title and Secret are not empty
        handleCreateSecret(title, secret, visibility.toLowerCase());
        setTitle("");
        setSecret("");
        setVisibility(myUserPerms?.is_owner ? "Owner" : myUserPerms?.is_admin ? "Admin" : "User")
        resetForm();
    };

    const handleCancel = () => {
        resetForm();
        handleSecretModalClose();
    };

    const handleClickShowPassword = () => {
        const currentCursorPos = inputRef.current.selectionStart;
        setShowPassword(!showPassword);
        setTimeout(() => {
        inputRef.current.setSelectionRange(currentCursorPos, currentCursorPos);
    }, 0);
  };

     const handleMouseDownPassword = (event) => {
        event.preventDefault(); 
  };


    const renderVisibilityMessage = () => {
        switch (visibility) {
            case 'Owner':
                return t("modal.secret_visibility_owner");
            case 'Admin':
                return t("modal.secret_visibility_admin");
            case 'User':
            default:
                return t("modal.secret_visibility_user");
        }
    };

    return (
        <Dialog open={openSecretModal} onClose={handleCancel} className="modal-background-color-secret">
            <DialogTitle>{t("modal.enter_secret")}</DialogTitle>
            <DialogContent className='secret-content'>
                <TextField
                    autoFocus={openSecretModal && title === ""}
                    margin="dense"
                    id="title"
                    label={t("calendar.event_title")}
                    type="text"
                    fullWidth
                    autoComplete="off"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    inputRef={inputRef}
                    InputLabelProps={{
                        className: "white-txt-color"
                    }}
                    InputProps={{
                        className: "white-txt-color"
                    }}
                />
            </DialogContent>
            <DialogContent className='secret-content'>
                <TextField
                    margin="dense"
                    id="secret"
                    label={t("modal.secret")}
                    type={showPassword ? 'text' : 'password'}
                    fullWidth
                    autoComplete="new-password"
                    value={secret}
                    onChange={(e) => setSecret(e.target.value)}
                    InputLabelProps={{
                        className: "white-txt-color"
                    }}
                    InputProps={{
                        className: "white-txt-color",
                         endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                              edge="end"
                            >
                              {showPassword ? <VisibilityOff sx={{ color: "#fff"}} /> : <Visibility sx={{ color: "#fff"}}/>}
                            </IconButton>
                          </InputAdornment>
                        ),
                    }}
                    inputRef={inputRef}
                />
                <Typography className="create-secret-encrypt-info"> {t("modal.password_encrypt")}</Typography>
            </DialogContent>
            <DialogContent className='secret-content'>
                <FormControl className="create-secret-form">
                    <InputLabel id="visibility-label" className="white-txt-color">
                        {t("global.visibility")}
                    </InputLabel>
                    <Select
                        labelId="visibility-label"
                        id="visibility"
                        value={visibility}
                        onChange={handleVisibilityChange}
                        MenuProps={{
                            PaperProps: {
                                className: "create-secret-select",
                            },
                        }}
                    >
                        {myUserPerms?.is_owner && (
                            <MenuItem value="Owner">{t("modal.owner")}</MenuItem>
                        )}
                        {(myUserPerms?.is_admin !== 0) && (
                            <MenuItem value="Admin">{t("modal.admin")}</MenuItem>
                        )}

                        <MenuItem value="User">{t("modal.user")}</MenuItem>
                    </Select>
                    <Typography className="create-secret-encrypt-info">
                        {renderVisibilityMessage()}
                    </Typography>
                </FormControl>
            </DialogContent>
            <DialogActions className='new-secret-flex'>
                <Button onClick={handleCancel} className="decline-button decline-button-secret">
                    <CancelIcon style={{ marginRight: 4 }} />
                    <span className="button-text">
                        {t("global.cancel")}
                    </span>
                </Button>
                <Button onClick={handleSaveSecret} disabled={avoidMisfire || title.trim() === "" || secret.trim() === ""} className="accept-button accept-button-secret">

                    <CheckCircleIcon style={{ marginRight: 4 }} />
                    <span className="button-text">
                        {t("modal.save_secret")}
                    </span>
                </Button>
            </DialogActions>
        </Dialog>
    );
}